import {isNonEmptyObject, isNonEmptyString} from "@tomeravni/easybizy-js-common/common";

export const generateCustomFontCssString = (fontFamily) => {
    if (!isNonEmptyObject(fontFamily)) {
        return null;
    }

    let cssContent = '';

    const filePrefix = fontFamily.filePrefix ? `${fontFamily.filePrefix}/` : '';

    Object.entries(fontFamily.files).forEach(([weight, fonts]) => {
        if (Object.keys(fonts).length === 0) return; // Skip if no font formats are defined

        let sources = [];
        if (fonts.woff2) sources.push(`url('/fonts/${filePrefix}${fonts.woff2}') format('woff2')`);
        if (fonts.woff) sources.push(`url('/fonts/${filePrefix}${fonts.woff}') format('woff')`);
        if (fonts.otf) sources.push(`url('/fonts/${filePrefix}${fonts.otf}') format('opentype')`);
        if (fonts.ttf) sources.push(`url('/fonts/${filePrefix}${fonts.ttf}') format('truetype')`);

        if (sources.length === 0) return; // Skip if no valid sources are present

        cssContent += `
            @font-face {
                font-family: 'CustomFont';
                font-weight: ${getFontWeight(weight)};
                font-style: normal;
                src: ${sources.join(', ')};
            }
        `;
    });

    return isNonEmptyString(cssContent) ? cssContent : null;
}


function getFontWeight(weight) {
    const weightMap = {
        light: 300,
        regular: 400,
        semiBold: 600,
        bold: 700,
        black: 900
    };
    return weightMap[weight] || 'normal';
}
